import React from "react";
import TourSummaryGigsRow from "./TourSummaryGigsRow";
import salesTotalsCalculator from "../helpers/salesTotalsCalculator";
import currencyFormat from "../helpers/currencyFormat";

const TourSummaryGigsTable = ({ token, tourId, gigs, products, sales, recipientNames, userIsEditor }) => {

  const totals = salesTotalsCalculator(sales, recipientNames);
  const venueCutTotal = gigs.reduce((acc, gig) => {
    return acc + gig.venueCut;
  }, 0);

  return (
    <table>
      <thead>
          <tr>
            <th className="left">date</th>
            <th className="left">venue</th>
            <th className="right">total revenue</th>
            <th className="right hideLtTablet">paypal comm.</th>
            <th className="right hideLtTablet">net revenue</th>
            {
              recipientNames.length > 0 && recipientNames.map((name, index) => {
                return (
                  <th className="right hideLtTablet" key={index}>{name}</th>
                )
              })
            }
            <th className="right hideLtTablet">venue cut</th>
            <th></th>
            <th></th>
            <th></th>
          </tr>
        </thead>
      <tbody>
        {
          gigs.length === 0
          ?
          (<tr><td colSpan="5">No Gigs added yet</td></tr>)
          :
          gigs.map(gig => {
            return (
              <TourSummaryGigsRow
                key={gig._id}
                token={token}
                tourId={tourId}
                gig={gig}
                recipientNames={recipientNames}
                products={products}
                tourSales={sales}
                userIsEditor={userIsEditor}
              />
            )
          })
        }
      </tbody>
      <tfoot>
      <tr className="totals">
            <td colSpan="2">totals</td>
            <td className="right">{currencyFormat(totals.totalRevenue / 100)}</td>
            <td className="right hideLtTablet">{currencyFormat(totals.paypalCommission / 100)}</td>
            <td className="right hideLtTablet">{currencyFormat((totals.netRevenue) / 100)}</td>
            {
              recipientNames.length > 0 && recipientNames.map((recipientName, index) => {
                const recipient = totals.recipientShares
                  .find(recipientShare => recipientShare.name === recipientName)
                  || { name: "", share: 0 };
                return (
                  <td className="right hideLtTablet" key={index}>{currencyFormat(recipient.share / 100)}</td>
                )
              })
            }
            <td className="right hideLtTablet">{currencyFormat(venueCutTotal / 100)}</td>
            <td colSpan="3" className="right">
              {/* <button
                id="showAddGigForm"
                type="button"
                className="button-link"
                onClick={toggleAddAGig}
              >{gigFormButtonText}</button> */}
            </td>
          </tr>
      </tfoot>
    </table>
  )

};

export default TourSummaryGigsTable;